import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type Subscription = components["schemas"]["SubscriptionResponse"];

/** GET /v1/billing/subscription — current Polar subscription status. */
export async function getSubscription(): Promise<Subscription> {
  return unwrap(await api.GET("/v1/billing/subscription"));
}
